const images = {
  logoDark: require('./logo-dark.png'),
  logoLight: require('./logo-light.png')
}

export default images
